import { TrucksTable } from '@/components/TrucksTable'
import { EquipmentStatus, isValidTruck, type Truck, useTrucks } from '@/models/equipment'
import { FillFieldKey } from '@/models/fillApplication'
import { RosterKind } from './FillJumpProvider'
import { RosterFrame } from './RosterFrame'

// The confirm checks only look at active equipment.
function isComplete(truck: Truck): boolean {
  return truck.status !== EquipmentStatus.ACTIVE || isValidTruck(truck)
}

export function TrucksRoster({ orgId }: { orgId: string }) {
  const { trucks, isLoading } = useTrucks({ orgId, shouldFetchAllPages: true })

  return (
    <RosterFrame
      title="Trucks"
      kind={RosterKind.TRUCKS}
      noun="truck"
      rows={trucks}
      isLoading={isLoading}
      isComplete={isComplete}
      fieldKey={FillFieldKey.EQUIPMENT}
      renderTable={(items, setItems, header) => (
        <TrucksTable
          trucks={items}
          setTrucks={setItems}
          orgId={orgId}
          enforceCarrierRequired
          searchable
          compact
          {...header}
        />
      )}
    />
  )
}
